exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.driver-container[data-v-7821778a] {\r\n  margin-left: 20px;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  margin-right: 20px;\r\n  padding: 15px 25px 15px 25px;\r\n  border: 1px solid #eaeaea;\r\n  width: 480px;\n}\r\n", ""]);

// exports
